import { SurveyState } from './state/SurveyState';
import { UserState } from "./state/UserState";
import { ActionReducer, ActionReducerMap, MetaReducer } from "@ngrx/store";
import { localStorageSync } from 'ngrx-store-localstorage';
import { userReducer } from "./reducer/UserReducer";
import { surveyReducer } from './reducer/SurveyReducer';
import { TrainingState } from './state/TrainingState';
import { trainingReducer } from './reducer/TrainingReducer';
import { brainstormReducer } from './reducer/BrainstormReducer';
import { BrainstormState } from './state/BrainstormState';
import { NotificationState } from './state/NotificationState';
import { notificationReducer } from './reducer/NotificationReducer';
import { CronosState } from './state/CronosState';
import { cronosReducer } from './reducer/CronosReducer';

export interface AppStore {
  userState: UserState;
  surveyState: SurveyState;
  trainingState: TrainingState;
  brainstormState: BrainstormState;
  notificationState: NotificationState;
  cronosState: CronosState;
}

export const reducers: ActionReducerMap<AppStore> = {
  userState: userReducer,
  surveyState: surveyReducer,
  trainingState: trainingReducer,
  brainstormState: brainstormReducer,
  notificationState: notificationReducer,
  cronosState: cronosReducer
};

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({ keys: ['userState', 'surveyState', 'trainingState', 'brainstormState', 'notificationState', 'cronosState'], rehydrate: true })(reducer);
}
export const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];


// WEBPACK FOOTER //
// ./src/store/AppStore.ts